const cruzeiro = [
  {
    id: 1,
    pais: "brasil",
    liga: "serie-a",
    time: "cruzeiro",
    nome: "Cruzeiro 26/27 - Uniforme 1",
    aliases: ["cruzeiro", "cabuloso", "raposa", "2026", "cruzeiro 2026"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/cruzeiro/26-27-01/cru0.jpg",
      "/images/brasil/serie-a/cruzeiro/26-27-01/cru1.jpg",
      "/images/brasil/serie-a/cruzeiro/26-27-01/cru2.jpg",
      "/images/brasil/serie-a/cruzeiro/26-27-01/cru3.jpg",
      "/images/brasil/serie-a/cruzeiro/26-27-01/cru4.jpg",
    ],
  },
  {
    id: 2,
    pais: "brasil",
    liga: "serie-a",
    time: "cruzeiro",
    nome: "Cruzeiro 26/27 - Uniforme de Treino (Azul)",
    aliases: ["cruzeiro", "cabuloso", "raposa", "2026", "cruzeiro 2026"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/cruzeiro/26-27-05-ta/cru0.jpg",
      "/images/brasil/serie-a/cruzeiro/26-27-05-ta/cru1.jpg",
      "/images/brasil/serie-a/cruzeiro/26-27-05-ta/cru2.jpg",
      "/images/brasil/serie-a/cruzeiro/26-27-05-ta/cru3.jpg",
      "/images/brasil/serie-a/cruzeiro/26-27-05-ta/cru4.jpg",
    ],
  },
  {
    id: 3,
    pais: "brasil",
    liga: "serie-a",
    time: "cruzeiro",
    nome: "Cruzeiro 25/26 - Uniforme 1",
    aliases: ["cruzeiro", "cabuloso", "raposa", "2025", "cruzeiro 2025"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/cruzeiro/25-26-01/cru0.jpg",
      "/images/brasil/serie-a/cruzeiro/25-26-01/cru1.jpg",
      "/images/brasil/serie-a/cruzeiro/25-26-01/cru2.jpg",
      "/images/brasil/serie-a/cruzeiro/25-26-01/cru3.jpg",
      "/images/brasil/serie-a/cruzeiro/25-26-01/cru4.jpg",
    ],
  },
  {
    id: 4,
    pais: "brasil",
    liga: "serie-a",
    time: "cruzeiro",
    nome: "Cruzeiro 25/26 - Uniforme 1 (Feminino)",
    aliases: [
      "cruzeiro",
      "cabuloso",
      "raposa",
      "2025",
      "cruzeiro 2025",
      "cruzeiro feminino",
      "feminino cruzeiro",
      "feminino",
    ],
    tipo: "feminino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/cruzeiro/25-26-01-f/cru0.jpg",
      "/images/brasil/serie-a/cruzeiro/25-26-01-f/cru1.jpg",
      "/images/brasil/serie-a/cruzeiro/25-26-01-f/cru2.jpg",
      "/images/brasil/serie-a/cruzeiro/25-26-01-f/cru3.jpg",
      "/images/brasil/serie-a/cruzeiro/25-26-01-f/cru4.jpg",
    ],
  },
  {
    id: 5,
    pais: "brasil",
    liga: "serie-a",
    time: "cruzeiro",
    nome: "Cruzeiro 25/26 - Regata Azul ",
    aliases: [
      "cruzeiro",
      "cabuloso",
      "raposa",
      "2025",
      "cruzeiro 2025",
      "regata",
      "regata cruzeiro",
      "cruzeiro regata",
    ],
    tipo: "masculino",
    categoria: "regata",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/cruzeiro/25-26-01-re/cru0.jpg",
      "/images/brasil/serie-a/cruzeiro/25-26-01-re/cru1.jpg",
      "/images/brasil/serie-a/cruzeiro/25-26-01-re/cru2.jpg",
      "/images/brasil/serie-a/cruzeiro/25-26-01-re/cru3.jpg",
      "/images/brasil/serie-a/cruzeiro/25-26-01-re/cru4.jpg",
    ],
  },
  {
    id: 6,
    pais: "brasil",
    liga: "serie-a",
    time: "cruzeiro",
    nome: "Cruzeiro 25/26 - Uniforme 2",
    aliases: ["cruzeiro", "cabuloso", "raposa", "2025", "cruzeiro 2025"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/cruzeiro/25-26-02/cru0.jpg",
      "/images/brasil/serie-a/cruzeiro/25-26-02/cru1.jpg",
      "/images/brasil/serie-a/cruzeiro/25-26-02/cru2.jpg",
      "/images/brasil/serie-a/cruzeiro/25-26-02/cru3.jpg",
      "/images/brasil/serie-a/cruzeiro/25-26-02/cru4.jpg",
    ],
  },
  {
    id: 7,
    pais: "brasil",
    liga: "serie-a",
    time: "cruzeiro",
    nome: "Cruzeiro 25/26 - Uniforme 3",
    aliases: ["cruzeiro", "cabuloso", "raposa", "2025", "cruzeiro 2025"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/cruzeiro/25-26-03/cru0.jpg",
      "/images/brasil/serie-a/cruzeiro/25-26-03/cru1.jpg",
      "/images/brasil/serie-a/cruzeiro/25-26-03/cru2.jpg",
      "/images/brasil/serie-a/cruzeiro/25-26-03/cru3.jpg",
      "/images/brasil/serie-a/cruzeiro/25-26-03/cru4.jpg",
    ],
  },
  {
    id: 8,
    pais: "brasil",
    liga: "serie-a",
    time: "cruzeiro",
    nome: "Cruzeiro 25/26 - Uniforme de Goleiro",
    aliases: ["cruzeiro", "cabuloso", "raposa", "2025", "cruzeiro 2025"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/cruzeiro/25-26-05-g/cru0.jpg",
      "/images/brasil/serie-a/cruzeiro/25-26-05-g/cru1.jpg",
      "/images/brasil/serie-a/cruzeiro/25-26-05-g/cru2.jpg",
      "/images/brasil/serie-a/cruzeiro/25-26-05-g/cru3.jpg",
      "/images/brasil/serie-a/cruzeiro/25-26-05-g/cru4.jpg",
    ],
  },
  {
    id: 9,
    pais: "brasil",
    liga: "serie-a",
    time: "cruzeiro",
    nome: "Cruzeiro 25/26 - Uniforme de Pré Jogo",
    aliases: ["cruzeiro", "cabuloso", "raposa", "2025", "cruzeiro 2025"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/cruzeiro/25-26-05-pj/cru0.jpg",
      "/images/brasil/serie-a/cruzeiro/25-26-05-pj/cru1.jpg",
      "/images/brasil/serie-a/cruzeiro/25-26-05-pj/cru2.jpg",
      "/images/brasil/serie-a/cruzeiro/25-26-05-pj/cru3.jpg",
      "/images/brasil/serie-a/cruzeiro/25-26-05-pj/cru4.jpg",
    ],
  },
  {
    id: 10,
    pais: "brasil",
    liga: "serie-a",
    time: "cruzeiro",
    nome: "Cruzeiro 25/26 - Regata Azul ",
    aliases: [
      "cruzeiro",
      "cabuloso",
      "raposa",
      "2025",
      "cruzeiro 2025",
      "regata",
      "regata cruzeiro",
      "cruzeiro regata",
    ],
    tipo: "masculino",
    categoria: "regata",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/cruzeiro/25-26-05-rea/cru0.jpg",
      "/images/brasil/serie-a/cruzeiro/25-26-05-rea/cru1.jpg",
      "/images/brasil/serie-a/cruzeiro/25-26-05-rea/cru2.jpg",
      "/images/brasil/serie-a/cruzeiro/25-26-05-rea/cru3.jpg",
      "/images/brasil/serie-a/cruzeiro/25-26-05-rea/cru4.jpg",
    ],
  },
  {
    id: 11,
    pais: "brasil",
    liga: "serie-a",
    time: "cruzeiro",
    nome: "Cruzeiro 25/26 - Uniforme de Treino (Azul)",
    aliases: ["cruzeiro", "cabuloso", "raposa", "2025", "cruzeiro 2025"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/cruzeiro/25-26-05-ta/cru0.jpg",
      "/images/brasil/serie-a/cruzeiro/25-26-05-ta/cru1.jpg",
      "/images/brasil/serie-a/cruzeiro/25-26-05-ta/cru2.jpg",
      "/images/brasil/serie-a/cruzeiro/25-26-05-ta/cru3.jpg",
      "/images/brasil/serie-a/cruzeiro/25-26-05-ta/cru4.jpg",
    ],
  },
  {
    id: 12,
    pais: "brasil",
    liga: "serie-a",
    time: "cruzeiro",
    nome: "Cruzeiro 24/25 - Uniforme 1",
    aliases: ["cruzeiro", "cabuloso", "raposa", "2024", "cruzeiro 2024"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/cruzeiro/24-25-01/cru0.jpg",
      "/images/brasil/serie-a/cruzeiro/24-25-01/cru1.jpg",
      "/images/brasil/serie-a/cruzeiro/24-25-01/cru2.jpg",
      "/images/brasil/serie-a/cruzeiro/24-25-01/cru3.jpg",
      "/images/brasil/serie-a/cruzeiro/24-25-01/cru4.jpg",
    ],
  },
  {
    id: 13,
    pais: "brasil",
    liga: "serie-a",
    time: "cruzeiro",
    nome: "Cruzeiro 24/25 - Uniforme 1",
    aliases: ["cruzeiro", "cabuloso", "raposa", "2024", "cruzeiro 2024"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/cruzeiro/24-25-02/cru0.jpg",
      "/images/brasil/serie-a/cruzeiro/24-25-02/cru1.jpg",
      "/images/brasil/serie-a/cruzeiro/24-25-02/cru2.jpg",
      "/images/brasil/serie-a/cruzeiro/24-25-02/cru3.jpg",
      "/images/brasil/serie-a/cruzeiro/24-25-02/cru4.jpg",
    ],
  },
  {
    id: 14,
    pais: "brasil",
    liga: "serie-a",
    time: "cruzeiro",
    nome: "Cruzeiro 24/25 - Uniforme 1",
    aliases: ["cruzeiro", "cabuloso", "raposa", "2024", "cruzeiro 2024"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/cruzeiro/24-25-03/cru0.jpg",
      "/images/brasil/serie-a/cruzeiro/24-25-03/cru1.jpg",
      "/images/brasil/serie-a/cruzeiro/24-25-03/cru2.jpg",
      "/images/brasil/serie-a/cruzeiro/24-25-03/cru3.jpg",
      "/images/brasil/serie-a/cruzeiro/24-25-03/cru4.jpg",
    ],
  },
  {
    id: 15,
    pais: "brasil",
    liga: "serie-a",
    time: "cruzeiro",
    nome: "Cruzeiro 24/25 - Uniforme 2 (Feminino)",
    aliases: [
      "cruzeiro",
      "cabuloso",
      "raposa",
      "2024",
      "cruzeiro 2024",
      "cruzeiro feminino",
      "feminino cruzeiro",
      "feminino",
    ],
    tipo: "feminino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/cruzeiro/24-25-02-f/cru0.jpg",
      "/images/brasil/serie-a/cruzeiro/24-25-02-f/cru1.jpg",
      "/images/brasil/serie-a/cruzeiro/24-25-02-f/cru2.jpg",
      "/images/brasil/serie-a/cruzeiro/24-25-02-f/cru3.jpg",
      "/images/brasil/serie-a/cruzeiro/24-25-02-f/cru4.jpg",
    ],
  },
  {
    id: 16,
    pais: "brasil",
    liga: "serie-a",
    time: "cruzeiro",
    nome: "Cruzeiro 24/25 - Calção 1",
    aliases: [
      "cruzeiro",
      "cabuloso",
      "raposa",
      "2024",
      "cruzeiro 2024",
      "cruzeiro calção",
      "calção cruzeiro",
      "calção",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/cruzeiro/24-25-01-c/cru0.jpg",
      "/images/brasil/serie-a/cruzeiro/24-25-01-c/cru1.jpg",
      "/images/brasil/serie-a/cruzeiro/24-25-01-c/cru2.jpg",
      "/images/brasil/serie-a/cruzeiro/24-25-01-c/cru3.jpg",
      "/images/brasil/serie-a/cruzeiro/24-25-01-c/cru4.jpg",
    ],
  },
  {
    id: 17,
    pais: "brasil",
    liga: "serie-a",
    time: "cruzeiro",
    nome: "Cruzeiro 23/24 - Uniforme Edição Especial",
    aliases: ["cruzeiro", "cabuloso", "raposa", "2023", "cruzeiro 2023"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/cruzeiro/23-24-00-es/cru0.jpg",
      "/images/brasil/serie-a/cruzeiro/23-24-00-es/cru1.jpeg",
      "/images/brasil/serie-a/cruzeiro/23-24-00-es/cru2.jpg",
      "/images/brasil/serie-a/cruzeiro/23-24-00-es/cru3.jpg",
      "/images/brasil/serie-a/cruzeiro/23-24-00-es/cru4.jpg",
    ],
  },
  {
    id: 18,
    pais: "brasil",
    liga: "serie-a",
    time: "cruzeiro",
    nome: "Cruzeiro 23/24 - Jaqueta Preta",
    aliases: ["cruzeiro", "cabuloso", "raposa", "2023", "cruzeiro 2023"],
    tipo: "masculino",
    categoria: "jaqueta",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/cruzeiro/23-24-00-jp/cru0.jpg",
      "/images/brasil/serie-a/cruzeiro/23-24-00-jp/cru1.jpg",
      "/images/brasil/serie-a/cruzeiro/23-24-00-jp/cru2.jpg",
      "/images/brasil/serie-a/cruzeiro/23-24-00-jp/cru3.jpg",
      "/images/brasil/serie-a/cruzeiro/23-24-00-jp/cru4.jpg",
    ],
  },
  {
    id: 19,
    pais: "brasil",
    liga: "serie-a",
    time: "cruzeiro",
    nome: "Cruzeiro 22/23 - Uniforme 1",
    aliases: ["cruzeiro", "cabuloso", "raposa", "2022", "cruzeiro 2022"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/cruzeiro/22-23-01/cru0.jpg",
      "/images/brasil/serie-a/cruzeiro/22-23-01/cru1.jpg",
      "/images/brasil/serie-a/cruzeiro/22-23-01/cru2.jpg",
      "/images/brasil/serie-a/cruzeiro/22-23-01/cru3.jpg",
      "/images/brasil/serie-a/cruzeiro/22-23-01/cru4.jpg",
    ],
  },
  {
    id: 20,
    pais: "brasil",
    liga: "serie-a",
    time: "cruzeiro",
    nome: "Cruzeiro 22/23 - Uniforme Edição Especial",
    aliases: ["cruzeiro", "cabuloso", "raposa", "2022", "cruzeiro 2022"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/cruzeiro/22-23-00-es/cru0.jpg",
      "/images/brasil/serie-a/cruzeiro/22-23-00-es/cru1.jpg",
      "/images/brasil/serie-a/cruzeiro/22-23-00-es/cru2.jpg",
      "/images/brasil/serie-a/cruzeiro/22-23-00-es/cru3.jpg",
      "/images/brasil/serie-a/cruzeiro/22-23-00-es/cru4.jpg",
    ],
  },
  {
    id: 21,
    pais: "brasil",
    liga: "serie-a",
    time: "cruzeiro",
    nome: "Cruzeiro 21/22 - Uniforme 1",
    aliases: ["cruzeiro", "cabuloso", "raposa", "2021", "cruzeiro 2021"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/cruzeiro/21-22-01/cru0.jpg",
      "/images/brasil/serie-a/cruzeiro/21-22-01/cru1.jpg",
      "/images/brasil/serie-a/cruzeiro/21-22-01/cru2.jpg",
      "/images/brasil/serie-a/cruzeiro/21-22-01/cru3.jpg",
      "/images/brasil/serie-a/cruzeiro/21-22-01/cru4.jpg",
    ],
  },
  {
    id: 22,
    pais: "brasil",
    liga: "serie-a",
    time: "cruzeiro",
    nome: "Cruzeiro 21/22 - Uniforme 2",
    aliases: ["cruzeiro", "cabuloso", "raposa", "2021", "cruzeiro 2021"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/cruzeiro/21-22-02/cru0.jpg",
      "/images/brasil/serie-a/cruzeiro/21-22-02/cru1.jpg",
      "/images/brasil/serie-a/cruzeiro/21-22-02/cru2.jpg",
      "/images/brasil/serie-a/cruzeiro/21-22-02/cru3.jpg",
      "/images/brasil/serie-a/cruzeiro/21-22-02/cru4.jpg",
    ],
  },
  {
    id: 23,
    pais: "brasil",
    liga: "serie-a",
    time: "cruzeiro",
    nome: "Cruzeiro 21/22 - Uniforme 2 (Feminino)",
    aliases: [
      "cruzeiro",
      "cabuloso",
      "raposa",
      "2021",
      "cruzeiro 2021",
      "cruzeiro feminino",
      "feminino cruzeiro",
      "feminino",
    ],
    tipo: "feminino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/cruzeiro/21-22-02-f/cru0.jpg",
      "/images/brasil/serie-a/cruzeiro/21-22-02-f/cru1.jpg",
      "/images/brasil/serie-a/cruzeiro/21-22-02-f/cru2.jpg",
      "/images/brasil/serie-a/cruzeiro/21-22-02-f/cru3.jpg",
      "/images/brasil/serie-a/cruzeiro/21-22-02-f/cru4.jpg",
    ],
  },
  {
    id: 24,
    pais: "brasil",
    liga: "serie-a",
    time: "cruzeiro",
    nome: "Cruzeiro 20/21 - Uniforme 1",
    aliases: ["cruzeiro", "cabuloso", "raposa", "2020", "cruzeiro 2020"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/cruzeiro/20-21-01/cru0.jpg",
      "/images/brasil/serie-a/cruzeiro/20-21-01/cru1.jpg",
      "/images/brasil/serie-a/cruzeiro/20-21-01/cru2.jpg",
      "/images/brasil/serie-a/cruzeiro/20-21-01/cru3.jpg",
      "/images/brasil/serie-a/cruzeiro/20-21-01/cru4.jpg",
    ],
  },
  {
    id: 25,
    pais: "brasil",
    liga: "serie-a",
    time: "cruzeiro",
    nome: "Cruzeiro 20/21 - Uniforme 2",
    aliases: ["cruzeiro", "cabuloso", "raposa", "2020", "cruzeiro 2020"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/cruzeiro/20-21-02/cru0.jpg",
      "/images/brasil/serie-a/cruzeiro/20-21-02/cru1.jpg",
      "/images/brasil/serie-a/cruzeiro/20-21-02/cru2.jpg",
      "/images/brasil/serie-a/cruzeiro/20-21-02/cru3.jpg",
      "/images/brasil/serie-a/cruzeiro/20-21-02/cru4.jpg",
    ],
  },
  {
    id: 26,
    pais: "brasil",
    liga: "serie-a",
    time: "cruzeiro",
    nome: "Cruzeiro 20/21 - Uniforme 3",
    aliases: ["cruzeiro", "cabuloso", "raposa", "2020", "cruzeiro 2020"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/cruzeiro/20-21-03/cru0.jpg",
      "/images/brasil/serie-a/cruzeiro/20-21-03/cru1.jpg",
      "/images/brasil/serie-a/cruzeiro/20-21-03/cru2.jpg",
      "/images/brasil/serie-a/cruzeiro/20-21-03/cru3.jpg",
      "/images/brasil/serie-a/cruzeiro/20-21-03/cru4.jpg",
    ],
  },
  {
    id: 27,
    pais: "brasil",
    liga: "serie-a",
    time: "cruzeiro",
    nome: "Cruzeiro 14/15 - Uniforme de Goleiro Retro",
    aliases: [
      "cruzeiro",
      "cabuloso",
      "raposa",
      "2014",
      "cruzeiro 2014",
      "retro cruzeiro",
      "cruzeiro retro",
      "retro",
    ],
    tipo: "masculino",
    categoria: "retro",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/cruzeiro/14-15-00-ga-re/cru0.jpg",
      "/images/brasil/serie-a/cruzeiro/14-15-00-ga-re/cru1.jpg",
      "/images/brasil/serie-a/cruzeiro/14-15-00-ga-re/cru2.jpg",
      "/images/brasil/serie-a/cruzeiro/14-15-00-ga-re/cru3.jpg",
      "/images/brasil/serie-a/cruzeiro/14-15-00-ga-re/cru4.jpg",
    ],
  },
  {
    id: 28,
    pais: "brasil",
    liga: "serie-a",
    time: "cruzeiro",
    nome: "Cruzeiro 93/94 - Uniforme 1 Retro",
    aliases: [
      "cruzeiro",
      "cabuloso",
      "raposa",
      "1993",
      "cruzeiro 1993",
      "retro cruzeiro",
      "cruzeiro retro",
      "retro",
    ],
    tipo: "masculino",
    categoria: "retro",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/cruzeiro/93-94-01-rt/cru0.jpg",
      "/images/brasil/serie-a/cruzeiro/93-94-01-rt/cru1.jpg",
      "/images/brasil/serie-a/cruzeiro/93-94-01-rt/cru2.jpg",
      "/images/brasil/serie-a/cruzeiro/93-94-01-rt/cru3.jpg",
      "/images/brasil/serie-a/cruzeiro/93-94-01-rt/cru4.jpg",
    ],
  },
  {
    id: 29,
    pais: "brasil",
    liga: "serie-a",
    time: "cruzeiro",
    nome: "Cruzeiro 93/94 - Uniforme 2 Retro",
    aliases: [
      "cruzeiro",
      "cabuloso",
      "raposa",
      "1993",
      "cruzeiro 1993",
      "retro cruzeiro",
      "cruzeiro retro",
      "retro",
    ],
    tipo: "masculino",
    categoria: "retro",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/cruzeiro/93-94-02-rt/cru0.jpg",
      "/images/brasil/serie-a/cruzeiro/93-94-02-rt/cru1.jpg",
      "/images/brasil/serie-a/cruzeiro/93-94-02-rt/cru2.jpg",
      "/images/brasil/serie-a/cruzeiro/93-94-02-rt/cru3.jpg",
      "/images/brasil/serie-a/cruzeiro/93-94-02-rt/cru4.jpg",
    ],
  },
];
export default cruzeiro;
